/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    object, bool, func, string, shape,
} from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { format } from 'date-fns';
import DeliveryCalendar from './Partials/DeliveryCalendar/DeliveryCalendar';
import DeliveryCalendarContainerV2 from './DeliveryCalendarContainerV2';
import DeliveryFoodCalendarV2 from './DeliveryFoodCalendarV2/DeliveryFoodCalendarV2';
import CalendarNotAvailableModal from '../CalendarNotAvailableModal/CalendarNotAvailableModal';
import GraphqlGetDisplayDeliveryCalendar from './GraphqlGetDisplayDeliveryCalendar/GraphqlGetDisplayDeliveryCalendar';

import { updateOrder } from '../../../../../../../state/ducks/MfeCheckout/ducks/Cart/ducks/UpdateCart/UpdateCart-Actions';
import { clearErrors, getError } from '../../../../../../../state/ducks/Checkout/ducks/Common/ducks/Error/Error-Actions';
import * as showLoadingMessageActions from '../../../../../../../state/ducks/Checkout/ducks/Common/ducks/ShowLoadingMessage/ShowLoadingMessage-Actions';
import * as commonSelector from '../../../../../../../state/ducks/Checkout/ducks/Common/Common-Selectors';
import * as calendarUtility from './Partials/CalendarView/helpers/calendarUtility';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { getFormattedDate } from '../Helpers/Helper';

class DeliveryCalendarContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            areYouSureCloseCalendar: false,
        };
    }

    componentDidMount() {
        const { callTrackEvent, featureFlags } = this.props;

        let eventLabel = 'Control';
        if (featureFlags['is-new-food-holiday-calendar-enabled']) {
            eventLabel = 'Variant';
        }

        callTrackEvent({
            eventCategory: 'Checkout',
            eventAction: 'New Food Calendar',
            eventLabel: `${eventLabel} Impression`,
        });
    }

    closeAreYouSureMessage = () => {
        this.setState({
            areYouSureCloseCalendar: false,
        });
    }

    handleAreYouSureCloseCalendar = (isCalendarSelectionChanged) => {
        const { handleDeliveryCalendarOpenClose } = this.props;

        if (isCalendarSelectionChanged) {
            this.setState({
                areYouSureCloseCalendar: true,
            });
        } else {
            handleDeliveryCalendarOpenClose();
        }
    }

    updateDeliveryDate = (
        deliveryDateDetails, forceExactDay,
        selectedDateAnHoliday, holidaySelected,
        guaranteedMethod,
    ) => {
        const {
            orderItem, pageProcess, callUpdateOrder, handleDeliveryCalendarOpenClose,
        } = this.props;

        const {
            holidayStartDate, holidayCode, deliverySLA,
            calendarDateType, rangeStartDate, deliveryDate,
            weekOfCode,
        } = deliveryDateDetails;

        let delSLA = deliverySLA;
        let calDateType = calendarDateType;
        let calStartDate = rangeStartDate;
        let updateHolidayCode;
        let selectedHolidaycode = '';

        if (holidayCode && Array.isArray(holidayCode)) {
            selectedHolidaycode = (holidayCode.includes(holidaySelected)) ? holidaySelected : '';
        } else {
            selectedHolidaycode = holidayCode;
        }

        if (selectedDateAnHoliday && holidayStartDate && selectedHolidaycode) {
            calStartDate = holidayStartDate;
        }

        if (selectedDateAnHoliday && selectedHolidaycode) {
            updateHolidayCode = selectedHolidaycode;
        } else if (weekOfCode) {
            updateHolidayCode = weekOfCode;
        } else {
            updateHolidayCode = '';
        }

        if (forceExactDay && calDateType === 'between') {
            delSLA = guaranteedMethod;
            calDateType = 'on';
            calStartDate = '';
        }

        const formattedDeliveryDate = getFormattedDate(deliveryDate, 'MM/dd/yyyy HH:mm:ss');

        let calStartDateValue = null;
        if (calStartDate) {
            calStartDateValue = getFormattedDate(calStartDate, 'MM/dd/yyyy HH:mm:ss');
        }

        const updateDeliveryDate = {
            backupProductCode: '',
            calendarDateType: calDateType,
            calendarStartDate: calStartDateValue || '',
            deliveryDate: formattedDeliveryDate,
            deliverySLA: delSLA,
            deliveryTimeWindow: '',
            flex: {},
            holidayCode: updateHolidayCode,
            locationType: '',
            useDateForAll: '',
            zipCode: '',
        };

        const reqObj = {
            updateDeliveryDate,
            quantity: null,
            orderItemId: orderItem.cartItemId,
        };

        const updateOrderProps = {
            page: pageProcess,
            updateType: 'delivery',
        };

        callUpdateOrder(reqObj, updateOrderProps, handleDeliveryCalendarOpenClose);
    }

    renderDeliveryCalendar = (deliveryDate, orderItem) => {
        const {
            callClearErrors, callGetError,
            error, featureFlags, updateShowLoadingMessage,
            flagOffShowLoadingMessage, deliveryCalOpen,
            deliveryTextData, handleDeliveryCalendarOpenClose,
            zipCode,
        } = this.props;

        const { areYouSureCloseCalendar } = this.state;

        let DeliveryCalendarComponent = DeliveryCalendar;
        if (featureFlags['is-new-food-holiday-calendar-enabled']) {
            DeliveryCalendarComponent = DeliveryFoodCalendarV2;
        }
        console.log('component', deliveryDate);
        return (
            <DeliveryCalendarComponent
                isOpen={deliveryCalOpen}
                closeDeliveryCalModel={handleDeliveryCalendarOpenClose}
                orderItemId={orderItem.cartItemId}
                selectedDate={deliveryDate}
                updateDeliveryDate={this.updateDeliveryDate}
                updateShowLoadingMessage={updateShowLoadingMessage}
                flagOffShowLoadingMessage={flagOffShowLoadingMessage}
                deliveryTextData={deliveryTextData}
                orderItem={orderItem}
                zipCode={zipCode}
                handleAreYouSureCloseCalendar={this.handleAreYouSureCloseCalendar}
                areYouSureCloseCalendar={areYouSureCloseCalendar}
                closeAreYouSureMessage={this.closeAreYouSureMessage}
            />
        );
    }

    renderDeliveryCalendarV2 = () => {
        const {
            orderItem,
            close,
            isOpen,
            selectedItemId,
            productDeliveryType,
            setCalendarDataLoadingFlag,
            handleDeliveryAvailability,
            orderItemId,
            brandId,
            pageType,
            sympathyValue,
            partNumber,
            ageDetails,
            subscriptionTypeAttribute,
            locationType,
            recipientState,
            ldClient,
            openCalendar,
            isCalendarLoading,
            deliveryNotAvailable,
            featureFlags,
            zipCode,
            handleDeliveryCalendarClose,
            handleDeliveryNotAvailable,
        } = this.props;

        return (
            <>
                <DeliveryCalendarContainerV2
                    close={close}
                    isOpen={isOpen}
                    selectedItemId={selectedItemId}
                    productDeliveryType={productDeliveryType}
                    setCalendarDataLoadingFlag={setCalendarDataLoadingFlag}
                    handleDeliveryAvailability={handleDeliveryAvailability}
                    orderItemId={orderItemId}
                    brandId={brandId}
                    pageType={pageType}
                    sympathyValue={sympathyValue}
                    partNumber={partNumber}
                    ageDetails={ageDetails}
                    subscriptionTypeAttribute={subscriptionTypeAttribute}
                    locationType={locationType}
                    recipientState={recipientState}
                    ldClient={ldClient}
                    openCalendar={openCalendar}
                    isCalendarLoading={isCalendarLoading}
                    deliveryNotAvailable={deliveryNotAvailable}
                    featureFlags={featureFlags}
                    zipCode={zipCode}
                    orderItem={orderItem}
                />
                {deliveryNotAvailable && (
                    <CalendarNotAvailableModal
                        isOpen={deliveryNotAvailable}
                        onClose={() => {
                            handleDeliveryNotAvailable(false);
                            handleDeliveryCalendarClose();
                        }}
                    />
                )}
            </>
        );
    }

    render() {
        const {
            brandId,
            deliveryDate,
            orderItem,
            productDeliveryType,
            featureFlags,
            userGroup,
            trackClickThrough,
        } = this.props;
        const objDeliveryDate = (deliveryDate) ? new Date(deliveryDate) : new Date();
        const selDeliveryDate = calendarUtility.convertDateObjToDateStr(objDeliveryDate);
        const gptCalendarABTest = () => {
            if (featureFlags['is-new-delivery-calendar-ab-test-enabled'] && userGroup === 'Test' && productDeliveryType === 'GPT') {
                trackClickThrough();
                return true;
            }
            return false;
        };
        const isDeliveryCalendarV2Enabled = () => (featureFlags['is-new-delivery-calendar-enabled'] || (!featureFlags['is-new-delivery-calendar-enabled'] && featureFlags['is-new-delivery-calendar-checkout-enabled']));

        return (
            <>
                <GraphqlGetDisplayDeliveryCalendar
                    brandId={brandId}
                    productSku={orderItem.product.parentProductCode}
                    render={({ displayDeliveryCalendar }) => (
                        ((isDeliveryCalendarV2Enabled() && displayDeliveryCalendar) || (isDeliveryCalendarV2Enabled() && gptCalendarABTest()) ? this.renderDeliveryCalendarV2() : this.renderDeliveryCalendar(selDeliveryDate, orderItem))
                    )}
                />
            </>
        );
    }
}

DeliveryCalendarContainer.propTypes = {
    deliveryCalOpen: bool.isRequired,
    orderItem: object.isRequired,
    error: shape({
        calendar: string,
    }),
    deliveryTextData: shape({
        deliveryHeaderTitle: string,
        deliveryHeaderCaption: string,
    }),
    deliveryDate: string.isRequired,
    updateShowLoadingMessage: func.isRequired,
    flagOffShowLoadingMessage: func.isRequired,
    handleDeliveryCalendarOpenClose: func.isRequired,
    callClearErrors: func.isRequired,
    callGetError: func.isRequired,
    callTrackEvent: func.isRequired,
    pageProcess: string.isRequired,
    callUpdateOrder: func.isRequired,
    zipCode: string.isRequired,
    featureFlags: object.isRequired,
    selectedItemId: string.isRequired,
    productDeliveryType: string.isRequired,
    setCalendarDataLoadingFlag: func.isRequired,
    brandId: string.isRequired,
    locationType: string.isRequired,
    partNumber: string.isRequired,
    close: func.isRequired,
    isOpen: bool.isRequired,
    handleDeliveryAvailability: func.isRequired,
    ageDetails: shape({
        birthDay: string,
        birthMonth: string,
        birthYear: string,
        minAge: string,
    }).isRequired,
    orderItemId: string,
    sympathyValue: string,
    pageType: string,
    subscriptionTypeAttribute: string,
    recipientState: string,
    ldClient: object,
    openCalendar: bool.isRequired,
    isCalendarLoading: bool.isRequired,
    deliveryNotAvailable: bool.isRequired,
    handleDeliveryCalendarClose: func.isRequired,
    handleDeliveryNotAvailable: func.isRequired,
    userGroup: string,
    trackClickThrough: func,
};

DeliveryCalendarContainer.defaultProps = {
    deliveryTextData: {
        deliveryHeaderTitle: '',
        deliveryHeaderCaption: '',
    },
    error: {
        calendar: '',
    },
    orderItemId: '',
    pageType: '',
    sympathyValue: null,
    subscriptionTypeAttribute: null,
    recipientState: '',
    trackClickThrough: () => { },
    userGroup: null,
    ldClient: null,
};

const mapStateToProps = (state) => ({
    error: commonSelector.getError(state),
});

const mapDispatchToProps = (dispatch) => ({
    callUpdateOrder: bindActionCreators(updateOrder, dispatch),
    callClearErrors: bindActionCreators(clearErrors, dispatch),
    callGetError: bindActionCreators(getError, dispatch),
    callTrackEvent: bindActionCreators(trackEvent, dispatch),
    updateShowLoadingMessage: bindActionCreators(showLoadingMessageActions.updateShowLoadingMessage, dispatch),
    flagOffShowLoadingMessage: bindActionCreators(showLoadingMessageActions.flagOffShowLoadingMessage, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryCalendarContainer);
